module.exports = __webpack_public_path__ + "media/svg-new/boss3-9e8d3a70.svg";